import React from "react";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const rows = [
  ["Lifespan", "1 year (annual replacement)", "20+ years (12-yr color warranty)"],
  ["Fade resistance", "Poor", "Excellent"],
  ["Attracts termites", "Yes", "No"],
  ["Mold / fungus", "Common", "None"],
  ["Fire ignition risk", "High", "Lower"],
  ["Replacement frequency", "Every spring", "Once, then forget it"],
  ["Environmental impact", "Decomposes, requires harvesting", "Diverts tires from landfill"],
];

export default function Comparison() {
  return (
    <section
      data-testid="comparison-section"
      className="relative w-full py-28 sm:py-36 px-6 bg-[#0F0F0F] border-t border-[#1A1A1A]"
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0 }}
          className="mb-14 text-center max-w-2xl mx-auto"
        >
          <p className="text-xs tracking-[0.3em] uppercase text-[#C4451C] mb-5">
            side by side
          </p>
          <h2 className="font-marker text-[#E8E5DE] text-4xl sm:text-5xl leading-tight">
            Same job. Two very different products.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0 }}
          className="border border-[#262626] overflow-hidden"
          data-testid="comparison-table"
        >
          <div className="grid grid-cols-[1.2fr_1fr_1fr] text-[11px] sm:text-xs tracking-[0.25em] uppercase">
            <div className="p-4 sm:p-5 bg-[#141414] text-[#737373]">Attribute</div>
            <div className="p-4 sm:p-5 bg-[#141414] text-[#A3A3A3] border-l border-[#262626]">
              Wood mulch
            </div>
            <div className="p-4 sm:p-5 bg-[#141414] text-[#C4451C] border-l border-[#262626]">
              Rubber mulch
            </div>
          </div>
          {rows.map(([attr, wood, rubber], i) => (
            <div
              key={i}
              className="grid grid-cols-[1.2fr_1fr_1fr] text-sm sm:text-base border-t border-[#1F1F1F]"
            >
              <div className="p-4 sm:p-5 text-[#A3A3A3]">{attr}</div>
              <div className="p-4 sm:p-5 text-[#737373] border-l border-[#1F1F1F] flex items-center gap-2">
                <X size={14} className="text-[#525252]" />
                {wood}
              </div>
              <div className="p-4 sm:p-5 text-[#E8E5DE] border-l border-[#1F1F1F] flex items-center gap-2">
                <Check size={14} className="text-[#C4451C]" />
                {rubber}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
